import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../styles/Navbar.css';
import { Corporate_url } from '../../Config/Config';

const FALLBACK_PROFILE = '/images/profile-user.png';

const Navbar = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserDetails = async () => {
      const storedUserId = localStorage.getItem('user_id');
      const token = localStorage.getItem('token');

      if (!storedUserId || !token) {
        setUserDetails(null);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${Corporate_url}/api/user-details/${Number(storedUserId)}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        setUserDetails(response.data);
      } catch (error) {
        console.error('Error fetching user details:', error);
        setUserDetails(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Optional: Show a loading indicator
  }

  return (
    <div className='banner-div d-flex align-items-center justify-content-between'>
      <div className="main-logo-section">
        <a href="/home/TU0000">
          <img src='/images/polus.webp' alt="Logo" className="logo" />
        </a>
      </div>
      <div className='banner-title'>
        <span>SecretPass</span>
      </div>
      <div className='profile-label-section align-items-center'>
        {userDetails ? (
          <div className="user-profile d-flex align-items-center">
            <div className='profile-image1'>
              <img
                src={userDetails.profile_pic || FALLBACK_PROFILE}
                alt="Profile Pic"
                className='profile-pic'
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = FALLBACK_PROFILE;
                }}
              />
            </div>
            <div className="user-info">
              <span className="user-name">{`${userDetails.first_name || 'Guest'} ${userDetails.last_name || ''}`}</span>
              <span className="user-role">{userDetails.access_type === "1" ? "Admin" : "Employee"}</span>
            </div>
          </div>
        ) : (
          <div className="user-profile d-flex align-items-center">
            <div className='profile-image'>
              <img height={'50px'} width={'100%'} src="/images/profile-user.png" alt="Profile Pic" className='profile-pic' />
            </div>
            <div className="user-info">
              <span className="user-name">Guest</span>
              <span className="user-role">Visitor</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
